import "./checkbox.css";

const CheckBox = ({ id, title, checked, onChange }) => {
  return (
    <div className="checkbox-wrapper-19">
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <label htmlFor={id} className="check-box" />
      <span className="text">{title}</span>
    </div>
  );
};

export default CheckBox;
